import React, { useState } from 'react';
import { colors } from '../theme';
import RmaTimelineCard from './RmaTimelineCard';

const API_BASE = process.env.REACT_APP_API_URL;

export default function GuestRmaLookup({ serialNumber, rmas, onRmasFound, onOpenRma }) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | not_found | error | rate_limited

  const hasCases = Array.isArray(rmas) && rmas.length > 0;

  const handleLookup = async () => {
    const trimmed = email.trim();
    if (!trimmed || !trimmed.includes('@')) return;
    setStatus('loading');
    try {
      const res = await fetch(
        `${API_BASE}/public/device/${encodeURIComponent(serialNumber)}/rma-lookup`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: trimmed })
        }
      );
      if (res.status === 429) { setStatus('rate_limited'); return; }
      const data = await res.json();
      if (!res.ok) { setStatus('error'); return; }
      if (Array.isArray(data.rmas) && data.rmas.length > 0) {
        onRmasFound(data.rmas);
        setStatus('idle');
      } else {
        setStatus('not_found');
      }
    } catch {
      setStatus('error');
    }
  };

  if (hasCases) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {rmas.map(rma => (
          <RmaTimelineCard
            key={rma._id || rma.rmaId}
            rma={rma}
            onSelect={() => onOpenRma(rma)}
            showManage={false}
          />
        ))}
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap',
      padding: '0.65rem 0.85rem', borderRadius: 8,
      border: `1px solid ${colors.panelBorder}`,
      background: 'rgba(255,255,255,0.02)'
    }}>
      <span style={{ fontSize: '0.82rem', color: colors.textMuted, whiteSpace: 'nowrap', flexShrink: 0 }}>
        Active case on file — enter your email to view:
      </span>
      <input
        type="email"
        value={email}
        onChange={e => { setEmail(e.target.value); if (status !== 'idle') setStatus('idle'); }}
        onKeyDown={e => e.key === 'Enter' && handleLookup()}
        placeholder="your@email.com"
        style={{
          flex: '1 1 160px', minWidth: 0, padding: '0.4rem 0.6rem', borderRadius: 6,
          border: `1px solid ${status === 'not_found' ? 'rgba(248,113,113,0.4)' : colors.panelBorder}`,
          background: 'rgba(255,255,255,0.05)', color: colors.textStrong,
          fontSize: '0.82rem', outline: 'none'
        }}
      />
      <button
        onClick={handleLookup}
        disabled={status === 'loading' || !email.trim().includes('@')}
        style={{
          padding: '0.4rem 0.85rem', borderRadius: 6, fontWeight: 700, fontSize: '0.82rem',
          border: 'none', backgroundColor: colors.primary, color: '#0e1f18',
          cursor: status === 'loading' || !email.trim().includes('@') ? 'not-allowed' : 'pointer',
          opacity: status === 'loading' || !email.trim().includes('@') ? 0.45 : 1,
          flexShrink: 0
        }}
      >
        {status === 'loading' ? '…' : 'View'}
      </button>
      {status === 'not_found' && (
        <span style={{ width: '100%', fontSize: '0.78rem', color: colors.textMuted }}>
          No cases found for that email.
        </span>
      )}
      {(status === 'rate_limited' || status === 'error') && (
        <span style={{ width: '100%', fontSize: '0.78rem', color: colors.danger }}>
          {status === 'rate_limited' ? 'Too many attempts — try again shortly.' : 'Something went wrong. Please try again.'}
        </span>
      )}
    </div>
  );
}
